import {observable, computed} from 'mobx';
import _ from 'lodash';

class NmbrPayrollInfoState {
  Emoji;

  @observable paySchedules = [];
  @observable isLoading = false;
  @observable errors = false;

  receiveProps({isLoading, paySchedules, errors, Emoji}) {
    this.paySchedules = paySchedules;
    this.isLoading = isLoading;
    this.errors = errors;
    this.Emoji = Emoji;
  }

  @computed get hasMultipleBusinessEntities() {
    return _.uniqBy(this.paySchedules, 'businessEntityName').length > 1;
  }

  @computed get paySchedulesGroupedByEntity() {
    return _.groupBy(this.paySchedules, 'businessEntityName');
  }
}

export default NmbrPayrollInfoState;
